module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_19.f28e70ef.pdf";